import * as React from "react";
import {
    View,
    Text,
    StyleSheet,
} from "react-native";
import { globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {Button} from '../../../components/core/Button';
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData} from "../../../utils/globalConstant";

const WithdrawPaykassma = ({
   details,
   withDrawConfirmBtnClick,
}) => {

    return (
            <View style={{paddingHorizontal: 16}}>
                <FormTextLabel
                labelStyles={{ alignSelf: "flex-start", ...styles.withdrawErrTitle }}
                label={'Review Transaction'}
                />
                <View style={{borderColor: globalConfigurableData.borderColor,backgroundColor: globalConfigurableData.cardBgColor, borderWidth: 0.75, borderRadius: 8, marginVertical: 20}}>
                    {details?.map((item, index) => {
                    return (
                        <View
                            key={index}
                            style={[
                                {borderBottomWidth: 0.75,
                                    borderColor: globalConfigurableData.borderColor,
                                    paddingHorizontal: 15,
                                    paddingVertical: 10},
                                index === details.length - 1
                                    ? { borderBottomWidth: 0,}
                                    : null,
                            ]}
                        >
                            <FormTextLabel
                                labelStyles={{...globalFontStyle.appFontSmallText, color: globalConfigurableData.secondaryTextColor1, paddingBottom: 5}}
                                label={item.title}
                            />
                            <Text style={[{...globalFontStyle.appFontBody, color: globalConfigurableData.primaryTextColor1},
                                item.title === "Amount to be withdrawn"
                                    ? {...globalFontStyle.appFontSubHeading} : null]}>{item.value}</Text>
                        </View>
                    );
                })}</View>
                <Button
                    variant="primary"
                    onPress={withDrawConfirmBtnClick}
                    translate={true}
                    style={{ flex: 1, marginBottom: 20 }}
                >
                    Confirm Request
                </Button>
            </View>
    );
};



export default WithdrawPaykassma;

const styles = StyleSheet.create({

    withdrawErrTitle: {
        ...globalFontStyle.appFontHeading,
        color: globalConfigurableData.primaryTextColor1,
        //textAlign: "center",
    },

});
